export default "__VITE_ASSET__F3XIpG4K__"